import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Total net income of the selected Retained Net Incomes, the most that can be
// distributed to the owners
export const getNetIncomeAvailable = async (retainedNetIncomeIds) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/profit_distribution/getNetIncomeAvailable`,
      { params: { ids: retainedNetIncomeIds.join(",") } },
    );
    return Number(response.data?.net_income) || 0;
  } catch (error) {
    throw error;
  }
};
